import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthUsersGuard} from '../../../resources/guards/authUsers.guard';
import {IconHouseUserComponent} from '../../../resources/components/icons/icon-house-user/icon-house-user.component';
import {ModeratorsComponent} from '../moderators.component';
import {ModeratorEditComponent} from '../moderator-edit/moderator-edit.component';
import {ModeratorCreateComponent} from '../moderator-create/moderator-create.component';
import {ModeratorIndexComponent} from '../moderator-index/moderator-index.component';
import {FormChangesGuard} from '../../../resources/guards/formChanges.guard';

export const ModeratorRoutes: Routes = [

  {
    path: 'moderators',
    data: {
      title: 'Moderators',
      icon: IconHouseUserComponent,
      permission: 'ModeratorsComponent'
    },
    component: ModeratorsComponent,
    canActivate: [AuthUsersGuard],
    canDeactivate: [FormChangesGuard],
    children: [{
      path: '',
      data: {
        title: 'Moderator',
      },
      component: ModeratorIndexComponent,
      canActivate: [AuthUsersGuard]
    },
      {
        path: 'create',
        data: {
          title: 'Create moderator',
        },
        component: ModeratorCreateComponent,
        canActivate: [AuthUsersGuard]
      },
      {
        path: 'edit/:id',
        data: {
          title: 'Edit moderator',
        },
        component: ModeratorEditComponent,
        canActivate: [AuthUsersGuard]
      }
    ],
  },

];

@NgModule({
  imports: [RouterModule.forChild(ModeratorRoutes)],
  exports: [RouterModule]
})
export class ModeratorsRoutesModule {
}
